import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
const messages = defineMessages({
  saved: {
    id: 'App.ApplicationProfile.Snapshot.DesiredMoveInDateRow.Saved',
    defaultMessage: 'Desired Move-In date saved',
  },
  saveFailed: {
    id: 'App.ApplicationProfile.Snapshot.DesiredMoveInDateRow.SaveFailed',
    defaultMessage: 'The Desired Move-In date could not be saved',
  },
});

export default messages;
